module.exports = __webpack_public_path__ + "static/media/innovative.48011676.svg";